var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order",style:({'border-bottom-color': _vm.index<4?'#5BAED3':'#B9DDED'})},[_c('span',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.indexNumber))])])}
var staticRenderFns = []

export { render, staticRenderFns }